import React, { useEffect, useState } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty } from "lodash";
import { setHeading } from "../../../accounts/account.actions";
import { GetShopByAreaApi } from "../AddShop/Shop.action";
import { getUserRes } from "../../AddUser/user.actions";
import { GlobalSpinner, showSuccessAlert, showErrorAlert } from "../../../../../global/globalFunctions";
import { GetAreaApi } from "../AddArea/areaAction";
import { searchAccountLedgerTable, clearShopLedger } from "../OrderBooking/OrderBookingAction";
import { AddPaymentApi } from "./PaymentReceivingAction";
import Select from "react-select";
import moment from "moment";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const AddPaymentReceving = (props) => {
    const [areaId, setAreaId] = useState();
    const [areaName, setAreaName] = useState("");
    const [shopId, setShopId] = useState();
    const [shopName, setShopName] = useState("");
    const [bookerId, setBookerId] = useState("");
    const [bookerName, setBookerName] = useState("");
    const [payment, setPayment] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [receivedBy, setReceivedBy] = useState("");
    const [discountReason, setDiscountReason] = useState("");
    const [date, setDate] = useState(moment().format('YYYY-MM-DD'));


    function SavePaymentReceving() {
        props.AddPaymentApi({
            areaId: areaId,
            bookerId: bookerId,
            shopId,
            payment: Number(payment),
            date,
            discount: Number(discount),
            discountReason,
            receivedBy,
            closingBalance: props.shopLedgerData?.closingBalance || 0,
        },
            showSuccessAlert,
            showErrorAlert
        );
        setAreaId("");
        setAreaName("");
        setShopId("");
        setShopName("");
        setBookerId("");
        setBookerName("");
        setPayment(0);
        setDiscount(0);
        setDiscountReason("");
        setReceivedBy("");
        props.clearShopLedger();
    }

    const handleChangeArea = (selectedOption) => {
        setAreaId(selectedOption.value);
        setAreaName(selectedOption.label);
        props.GetShopByAreaApi(selectedOption.value);
    };
    const AreaListData = isEmpty(props.areaDataList) ? [] : props.areaDataList.map((x) => {
        let data = { value: x._id, label: x.areaName };
        return data;
    });

    const handleChangeShop = (selectedOption) => {
        setShopId(selectedOption.value);
        setShopName(selectedOption.label);
        props.searchAccountLedgerTable({ levelFourId: selectedOption.value, })
    };
    const ShopListData = isEmpty(props.shopsByAreaList) ? [] : props.shopsByAreaList.map((x) => {
        let data = { value: x._id, label: x.shopName };
        return data;
    });

    const handleChangeBooker = (selectedOption) => {
        setBookerId(selectedOption.value);
        setBookerName(selectedOption.label);
    };
    const filterdUserList = isEmpty(props.userList) ? [] : props.userList.filter((e) => e.role === "booker");
    const BookerList = !isEmpty(filterdUserList) && filterdUserList.map((x) => {
        let data = { value: x._id, label: x.userName };
        return data;
    });

    useEffect(() => {
        props.setHeading("Payment Receving");
        props.GetAreaApi();
        props.getUserRes();
    }, []);

    return (
        <>
            {props.isAddingPayment || props.isFetchingAreaData || props.isFetchingUser ? (
                <GlobalSpinner />
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Select Area *</b></Form.Label>
                                <Select
                                    isDisabled={isEmpty(props.areaDataList)}
                                    value={areaId ? { value: areaId, label: areaName } : null}
                                    placeholder="Select Area"
                                    onChange={handleChangeArea}
                                    options={AreaListData}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Select Shop *</b></Form.Label>
                                <Select
                                    isDisabled={isEmpty(props.shopsByAreaList) || isEmpty(areaName)}
                                    value={shopId ? { value: shopId, label: shopName } : null}
                                    placeholder="Select Shop"
                                    onChange={handleChangeShop}
                                    options={ShopListData}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Shop Balance </b> </Form.Label>
                                <Form.Control
                                    value={isEmpty(props.shopLedgerData) ? '' : `${props.shopLedgerData?.closingBalance} - ${props.shopLedgerData?.closingBalanceSign}`}
                                    disabled
                                    type="text"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                ></Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label><b>Select DSF *</b></Form.Label>
                                <Select
                                    value={bookerId ? { value: bookerId, label: bookerName } : null}
                                    placeholder="Select DSF"
                                    onChange={handleChangeBooker}
                                    options={BookerList}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Payment *</b></Form.Label>
                                <Form.Control
                                    type="number"
                                    onChange={(e) => { setPayment(e.target.value); }}
                                    value={payment}
                                    min={0}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Discount </b></Form.Label>
                                <Form.Control
                                    type="number"
                                    onChange={(e) => { setDiscount(e.target.value); }}
                                    value={discount}
                                    min={0}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Received By </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setReceivedBy(e.target.value); }}
                                    value={receivedBy}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana">
                                <Form.Label> <b>Discount Reason </b></Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setDiscountReason(e.target.value); }}
                                    value={discountReason}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {isEmpty(areaId) || isEmpty(shopId) || isEmpty(bookerId) || isEmpty(payment) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SavePaymentReceving}> SAVE </Button>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        AddPaymentApi: (data, showSuccessAlert, showErrorAlert) => dispatch(AddPaymentApi(data, showSuccessAlert, showErrorAlert)),
        GetAreaApi: () => dispatch(GetAreaApi()),
        GetShopByAreaApi: (shopId) => dispatch(GetShopByAreaApi(shopId)),
        searchAccountLedgerTable: (data) => dispatch(searchAccountLedgerTable(data)),
        getUserRes: () => dispatch(getUserRes()),
        setHeading: (data) => dispatch(setHeading(data)),
        clearShopLedger: () => dispatch(clearShopLedger()),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isAddingPayment: state.PaymentReceivingReducer.isAddingPayment,
    isFetchingAreaData: state.AreaReducer.isFetchingAreaData,
    areaDataList: state.AreaReducer.areaDataList,
    isFetchingShopsByArea: state.ShopReducer.isFetchingShopsByArea,
    shopsByAreaList: state.ShopReducer.shopsByAreaList,
    isFetchingUser: state.UserReducer.isFetchingUser,
    userList: state.UserReducer.userList,
    shopLedgerData: state.OrderBookingReducer.shopLedgerData,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPaymentReceving);